import type { ResolverTag } from '@ps/web-core-enums';
import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

interface Props {
  textTranslation?: TranslationTag;
  linkTranslation: TranslationTag;
  resolverTag: ResolverTag;
}

const InfoLink: React.FC<Props> = ({ textTranslation, linkTranslation, resolverTag }) => (
  <>
    {textTranslation && (
      <>
        <Translation {...textTranslation} />{' '}
      </>
    )}
    <Translation
      {...linkTranslation}
      values={{
        a: (msg: React.ReactNode) => <ResolverLink resolverTag={resolverTag}>{msg}</ResolverLink>
      }}
    />
  </>
);

export default InfoLink;
